// Role helpers. The effective role is read from app_metadata (server-managed
// via the profiles sync trigger in migration 012) — NEVER from user_metadata,
// which is user-writable and untrusted for authorization.
//
// Role hierarchy (high -> low):
//   super_admin > admin > support > analyst > vendor > member

export const ROLE_RANK = {
  super_admin: 6,
  admin: 5,
  support: 4,
  analyst: 3,
  vendor: 2,
  member: 1,
}

export function effectiveRole(user) {
  if (!user) return 'member'
  const role = user.app_metadata?.role
  // Only accept known roles; anything unknown degrades to member.
  return ROLE_RANK[role] ? role : 'member'
}

export function hasRole(user, required) {
  return ROLE_RANK[effectiveRole(user)] >= (ROLE_RANK[required] || 0)
}

export function isAdmin(user) {
  return effectiveRole(user) === 'admin' || effectiveRole(user) === 'super_admin'
}

export function isSupport(user) {
  return hasRole(user, 'support')
}

export function isSuperAdmin(user) {
  return effectiveRole(user) === 'super_admin'
}

export function roleLabel(role) {
  return (
    {
      super_admin: 'Super Admin',
      admin: 'Admin',
      support: 'Support',
      analyst: 'Analyst',
      vendor: 'Vendor',
      member: 'Member',
    }[role] || 'Member'
  )
}
